import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../components/AuthLayout';
import api from '../services/api';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const location = useLocation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const searchParams = new URLSearchParams(location.search);
        let org = searchParams.get('org');
        
        if (!org) {
            const hostname = window.location.hostname;
            const parts = hostname.split('.');
            // Support subdomain routing like nell.bizlinks.in or nell.localhost
            if (parts.length >= 2 && parts[0] !== 'www' && parts[0] !== 'api' && hostname !== 'localhost' && !/^[0-9.]+$/.test(hostname)) {
                org = parts[0];
            }
        }
        
        if (!org) {
            org = localStorage.getItem('orgContext');
        }

        try {
            const response = await api.post('/auth/forgot-password', { email, org: org || null });
            if (response.data.success) {
                setSubmitted(true);
                toast.success(response.data.message);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to process request');
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthLayout>
            <div className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900">Forgot Password</h2>
                <p className="text-sm text-gray-500 mt-2">
                    Enter your email address and we'll send you a link to reset your password.
                </p>
            </div>

            {!submitted ? (
                <form className="space-y-6" onSubmit={handleSubmit}>
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-500 mb-1">
                            Email address
                        </label>
                        <input
                            id="email"
                            name="email"
                            type="email"
                            placeholder="Enter your email"
                            required
                            className="block w-full rounded-md border border-gray-200 py-3 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-1 focus:ring-primary-600 sm:text-sm px-4"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full rounded-md bg-[#2196F3] px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 disabled:opacity-50 transition-all font-outfit"
                        >
                            {loading ? 'Sending link...' : 'Send Reset Link'}
                        </button>
                    </div>

                    <div className="text-center">
                        <Link to="/login" className="text-sm font-medium text-primary-500 hover:text-primary-600">
                            Back to login
                        </Link>
                    </div>
                </form>
            ) : (
                <div className="text-center space-y-6">
                    <div className="bg-green-50 p-6 rounded-lg border border-green-100">
                        <div className="flex justify-center mb-4">
                            <div className="h-12 w-12 bg-green-100 rounded-full flex items-center justify-center">
                                <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                </svg>
                            </div>
                        </div>
                        <h3 className="text-lg font-semibold text-green-900">Email Sent!</h3>
                        <p className="text-sm text-green-700 mt-2">
                            Check your inbox for the password reset link. 
                            The link will expire in 1 hour.
                        </p>
                    </div>
                    
                    <Link
                        to="/login"
                        className="inline-block rounded-md bg-gray-100 px-6 py-3 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-200 transition-all"
                    >
                        Return to Login
                    </Link>
                </div>
            )}
        </AuthLayout>
    );
};

export default ForgotPassword;
